import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NzModalRef, NzModalService } from "ng-zorro-antd/modal";
import { NzNotificationService } from "ng-zorro-antd/notification";
import { TranslateService } from "@ngx-translate/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NzUploadFile } from "ng-zorro-antd/upload";
import { map } from "rxjs/operators";
import * as moment from 'moment';
import * as _ from 'lodash';
import { HttpClient } from "@angular/common/http";
import { NzImageService } from 'ng-zorro-antd/image';
@Component({
  selector: 'pi-custom-field',
  templateUrl: './pi-custom-field.component.html',
  styleUrls: ['./pi-custom-field.component.scss']
})
export class PiCustomFieldComponent implements OnInit {
  @Input() customFieldData
  @Input() customFieldFormGroup
  @Input() index
  @Input() isOnlyShow = false
  @Input() showLabel = true
  //表单对齐
  @Input() labelSpan = 6
  @Input() controlSpan = 16

  @Input() Size = 'default'
  @Input() sameRow = true
  @Output() public outer = new EventEmitter();
  @Output() public time = new EventEmitter();

  //工序采集数据
  customRequest;
  previewImg;
  previewVisible
  ngOnInit(): void {
    //  if(this.customFieldData.fieldType==='Time'){
    //    if(this.customFieldData.fieldValue){
    //     let timer = new Date()
    //     let  time = timer.getFullYear()+'-'+timer.getMonth()+'-'+timer.getDay()+' '+ this.customFieldData.fieldValue
    //     this.customFieldData.fieldValue = new Date(time)
    //    }
    // }

  }

  constructor(
    public http: HttpClient,
    public modalService: NzModalService,
    public notification: NzNotificationService,
    public translateService: TranslateService,
    // private uploaderService: UploaderService,
    private nzImageService: NzImageService
  ) {
    //阿里云 OSS上传

    // this.customRequest = (item) => {
    //   return this.uploaderService.uploadRequestFile(item, 'processTemplate', templatePath => {
    //     this.loading = false
    //     this.outer.emit({ path: templatePath, index: this.uploadIndex, uploadName: this.uploadName })
    //   }, 'ten');
    // };
  }

  //提交图片
  uploadName
  uploadIndex
  handleChange(info: { file: NzUploadFile }, index: number): void {
    // console.log('handleChange', info)
    // console.log('customFieldData', this.customFieldData)
    // console.log('info',info)
    if (info && info['type'] && info['type'] === 'removed') {
      let fileIndex = this.customFieldData.fileList.findIndex(item => item.uid === info.file.uid)
      this.customFieldData.fileList.splice(fileIndex, 1)
      this.customFieldData.fieldValue.splice(fileIndex, 1)
      if(this.customFieldData.fileName){
        this.customFieldData.fileName.splice(fileIndex, 1)
      }
    }
    // this.loading = true
    this.uploadIndex = index;
    this.uploadName = info.file.name
  }
  loading = false
  handlePreview = async (file: NzUploadFile) => {
    if (!file.url && !file.preview) {
      // file.preview = await this.uploaderService.getBase64(file.originFileObj!);
    }
    this.previewImg = file.url || file.preview;
    this.previewVisible = true;
  }
  timechange(data) {
    console.log('timechange', data)
    this.time.emit(data)
  }
  //时间展示
  getmoment(time, format, flag = false) {
    if (time) {
      try {
        //bug处理:如果是时间 加个日期 error:Vaild Date
        let timeget
        if (flag) {
          let timer = new Date()
          time = timer.getFullYear() + '-' + timer.getMonth() + '-' + timer.getDay() + ' ' + time
        }
        timeget = moment(time).format(format)
        return timeget
      } catch (e) {
        return ""
      }
    }
    else {
      return ""
    }

  }
  setPathName(str) {
    if (str) {
      let temp = str.split('/')
      let len = temp.length - 1
      return temp[len]
    }
    else {
      return ""
    }
  }
  // 类型判断
  getType(type) {
    if(Object.prototype.toString.call(type)  == '[object Array]'){
      return 'Array'
    }
    if(Object.prototype.toString.call(type)  == '[object Object]'){
      return 'Object'
    }
    if(Object.prototype.toString.call(type)  == '[object String]'){
      return 'String'
    }
  }
  //  删除文件展示
  isdelete = false
  returnPlaceHolder(customFieldData) {
    if (customFieldData.fieldExtend && customFieldData?.fieldExtend?.hint) {
      return customFieldData?.fieldExtend?.hint
    }
    if (customFieldData?.hint) {
      return customFieldData?.hint
    }
    return ""
  }
  // ngAfterViewInit(){
  //   this.changDataToOption()
  // }
  // // 多选框字段转换
  // checkOption
  // changDataToOption(){
  //   if(this.customFieldData?.fieldType === 'MultiSelect'){
  //     this.customFieldData.checkOption = []
  //     this.customFieldData?.fieldExtend?.options.forEach(element => {
  //       this.customFieldData.checkOption.push({
  //         label:element,
  //         value:element,
  //         checked: this.isContains(element)
  //       })
  //     });
  //   }
  // }
  // isContains(value){
  //   let f = false
  //   if(this.customFieldData?.fieldExtend?.defaultValue){
  //     this.customFieldData?.fieldExtend?.defaultVal.forEach(element => {
  //       if(element ===value){
  //         f = true
  //       }
  //     });
  //   }
  //   return f
  // }
  //格式化日期
  parseDateTime(date) {
    if (!date) {
      return '-'
    } else {
      // let arr = date.split('T')
      // if (arr[0] && arr[1]) {
      //   return arr[0] + ' ' + arr[1]
      // } else if (arr[0] && !arr[1]) {
      //   return arr[0]
      // }
      return moment(date).format('YYYY-MM-DD HH:mm').toString()
    }
  }

  myDownSetName(fieldValue,fileName){
    console.log('202205调')
    console.log('fieldValue',fieldValue)
    console.log('fileName',fileName)
    try {
      this.http.get(fieldValue, { responseType: 'blob' }).subscribe(
        (response) => {
          const a = document.createElement('a')
          const objectUrl = URL.createObjectURL(response)
          a.href = objectUrl
          //文件下载名去掉后缀
          // 字符串拆分
          fileName = fileName.split('.')[0]
          const suffix =fieldValue.slice(fieldValue.lastIndexOf('.'));
          a.download = fileName+suffix
          
          a.click();
          URL.revokeObjectURL(objectUrl);
        }
      )
    } catch (e) {

    }
  }
  // 多选查看展示
  showMultiSelect(data) {
    if (!data.fieldValue) {
      return '-'
    }
    if (data && data['checkOption'] && data['checkOption'].length > 0) {
      let temp = ''
      data['checkOption'].forEach(o => {
        temp += o.checked ? o.label + ';' : ''
      });
      if(temp==''){
        return '-'
      }else{
        return temp
      }
    }else{
      return '-'
    }
  }
  // 匹配输入文件类型 word excel pdf 图片 及其他
  getFileType(fileName) {
    let fileType = ''
    if (fileName) {
      let temp = fileName.split('.')
      let len = temp.length - 1
      fileType = temp[len]
    }
    let typelist = [['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'], ['pdf'], ['jpg', 'png', 'jpeg', 'bmp', 'gif'], ['mp4', 'webm', 'ogg'], ['txt']]
    let type = ['office', 'pdf', 'image', 'video', 'text']
    for (let i = 0; i < typelist.length; i++) {
      //不区分大小写匹配
      if (typelist[i].indexOf(fileType.toLowerCase()) > -1) {
        return type[i]
      }
    }
    return 'other'
  }

  onClickImage(filepath): void {
    const images = [
      {
        src: filepath,
        width: '200px',
        height: '200px',
        alt: 'ng-zorro'
      },
    ];
    this.nzImageService.preview(images, { nzZoom: 1.5, nzRotate: 0 });
  }

  @ViewChild('videoplayer') videoplayerModal;
  videoplayer
  videoUrl = null
  onVideoShow(videoUrl): void {
    this.videoUrl = videoUrl
    this.videoplayer = this.modalService.create({
      nzTitle: '视频预览',
      nzStyle: { top: '5px' },
      nzWidth: '1200px',
      nzNoAnimation: true,
      nzContent: this.videoplayerModal,
      nzFooter: null,
    });
  }

  @ViewChild('text') textModal;
  text
  textUrl = null
  txtPre = null
  ontextShow(url): void {
    // this.textUrl = url
    this.http.get(url, { responseType: 'text' }).subscribe((res) => {
      this.txtPre = res
      this.textModal = this.modalService.create({
        nzTitle: 'text预览',
        nzStyle: { top: '5px' },
        nzWidth: '1200px',
        nzNoAnimation: true,
        nzContent: this.textModal,
        nzFooter: null,
      });
    })

  }

  // showIt(data){
  //   console.log('这是文件查看数据',data)
  // }
}
